export default "__VITE_ASSET__Ci4Lbz$o__"